import {Component, OnInit, ViewChild} from '@angular/core';
import {TaskModel} from '../../../models/task.model';
import {DxDataGridComponent} from 'devextreme-angular';
import {TaskService} from '../../../../provider/task.service';
import {MenuAsideService} from '../../../../core/_base/layout';

@Component({
  selector: 'kt-tasks',
  templateUrl: './tasks.component.html',
  styleUrls: ['./tasks.component.scss']
})
export class TasksComponent implements OnInit {
  ChatIsVisible = false;
  loading = true;
  currentTasks: TaskModel = new TaskModel();
  editorOptions: object;
  typeID = 'all';
  types: any[] = [];

  @ViewChild(DxDataGridComponent, {static: false}) dataGrid: DxDataGridComponent;

  tasks: TaskModel[];
  popupVisible = false;
  inProcess = false;
  managed = false;
  time = new Date().getTime();

  constructor(public taskService: TaskService,
              private menuAsideService: MenuAsideService) {
    this.editorOptions = {
      itemTemplate: 'statusTemplate'
    };
    this.taskService.getTasks();


  }

  filter(type: any) {
    this.typeID = type;
    if (type != 'all') {
      this.taskService.task_change_filtered$.next(this.taskService.task_change_filtered$.getValue().filter(x => x.assignment_type == type));
    } else {
      this.taskService.task_change_filtered$.next(this.taskService.task_change_filtered$.getValue());
    }
  }

  onRowPrepared(e) {
    if (e.rowType == 'data' && e.data.status == 'Managed') {
      e.rowElement.style.backgroundColor = '#32cd3259';
    }
  }

  ngOnInit() {
  }

  closeChat() {
    this.ChatIsVisible = false;
  }
}
